<template>
  <footer
    :class="['login-footer', singleStatus ? `footer-${configStyle}` : '']"
  >
    <span v-if="!isMobile && businessType === 'zlzp'" class="custom-footer-desc"
      >2022年智联招聘最佳雇主大会</span
    >
    <div class="gotin-powered" v-if="hasFooter">
      <span v-if="footerTitle" :class="[`footer-${configStyle}`]">{{
        footerTitle
      }}</span>
      <span v-else :class="[isMobile ? 'is-mobile' : '']">{{
        $t('login.components.loginFooter.powerText')
      }}</span>
      <img
        :src="logoColor ? LogoNewZL : LogoNew"
        alt="有了gotin"
        class="logo-new"
      />
    </div>
  </footer>
</template>
<script>
import LogoNew from '@/assets/images/login/logo-new.svg'
import LogoNewZL from '@/assets/images/login/logo-new-zl.svg'
import { getBusinessType } from '@/constant'
export default {
  name: 'LoginFooter',
  components: {},
  props: {
    logoColor: {
      type: Boolean,
      default: false,
    },
    footerTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      LogoNew,
      LogoNewZL,
    }
  },
  computed: {
    singleStatus() {
      return getBusinessType().hasOwnThemeStyle
    },
    configStyle() {
      return getBusinessType().className
    },
    businessType() {
      return getBusinessType().id
    },
    hasFooter() {
      return getBusinessType().hasFooter
    },
  },
}
</script>
<style lang="scss" scoped>
.footer-porsche-wrap {
  color: #fff;
  justify-content: center;
  align-items: flex-end !important;
}
.footer-zlzp-wrap {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  .is-mobile {
    color: #000;
  }
  .custom-footer-desc {
    color: #fff;
    padding-bottom: 12px;
  }
}

// 登录页面公共footer
.login-footer {
  color: #fff;
  font-size: 14px;
  bottom: 16px;
  flex: 1;
  line-height: 1.72em;
  display: flex;

  .logo-new {
    margin-left: 8px;
    height: 22px;
    color: #fff;
  }
  .custom-footer-desc {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
  }
  .gotin-powered {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.footer-aia-wrap {
  color: rgba(0, 0, 0, 0.8);
  font-size: 12px;
  line-height: 20px;
  opacity: 0.8;
  flex: unset;
  .logo-new {
    height: 20px;
  }
}

footer.footer-aia-wrap {
  padding: 20px 0;
}
</style>
